import { useEffect, useState } from 'react';

/**
 * The current time in unix seconds, refreshed every `intervalMs`.
 *
 * Relative labels ("in 4m", "2m ago") and the timeline's "now" marker read
 * this rather than calling Date.now() while rendering, so a whole page agrees
 * on what now is and re-renders together.
 */
export function useNowSeconds(intervalMs = 15_000): number {
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));
  useEffect(() => {
    const id = window.setInterval(() => setNow(Math.floor(Date.now() / 1000)), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
